export default "__VITE_ASSET__BYbABgQh__"